/** Page size for GET /api/feeds/puzzle — must match PuzzleFeed infinite query. */
export const PUZZLE_FEED_PAGE_LIMIT = 10;

/** Max additional feed pages to load when searching for the next playable property. */
export const PUZZLE_FEED_NEXT_MAX_PAGES = 25;

/**
 * React Query key for the puzzle property feed (shared by PuzzleFeed and next-puzzle lookup).
 */
export function getPuzzleFeedQueryKey(
    userId: string | undefined,
    slc: string | null | undefined,
): readonly [string, string | undefined, string | null] {
    return ["puzzle-feed", userId, slc ?? null];
}
